import { Injectable } from '@angular/core';
import { PlessHttp } from 'src/app/shared/http/pless-http.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessDialogServiceSub } from 'src/app/commons/kymw00/pless-dialog-service-sub';
import { KYMW7400Model } from '../kymw7400.model';

import type { GetRememberGoodsListCondition } from '../vo/get-remember-goods-list-condition.model';

// リクエスト構造
export interface GetRememberGoodsListRequest {
  search: {
    RememberGoodsList: {
      condition: GetRememberGoodsListCondition;
    };
  };
}

// レスポンス構造
export interface GetRememberGoodsListResponse {
  /** 全件数 */
  TotalNum: string;
  /** 表示開始件数 */
  StartDispNum: string;
  /** 表示終了件数 */
  EndDispNum: string;
  // 忘れず注文商品一覧
  RememberGoodsList: {
    /** ステータス */
    RememberGoodsStatus: string;
    /** ステータス名 */
    RememberGoodsStatusName: string;
    /** 注文コード */
    OrderNum: string;
    /** 部門コード */
    ClassCode: string;
    /** 部門名 */
    ClassName: string;
    /** バイヤーコード */
    BuyerCode: string;
    /** バイヤー名 */
    BuyerName: string;
    /** アイテムコード */
    ItemCode: string;
    /** Ｐコード */
    Pcode: string;
    /** 商品名 */
    GuideGoodsName: string;
    /** 規格名 */
    GuideStandardName: string;
    /** 受注受付開始企画回 */
    OrderReceptionStartCatalog: string;
    /** 受注受付終了企画回 */
    OrderReceptionEndCatalog: string;
    /** 配達開始企画回 */
    DeliveryStartCatalog: string;
    /** 配達終了企画回 */
    DeliveryEndCatalog: string;
    /** 配達サイクル区分 */
    DeliveryCycleDiv: string;
    /** 配達サイクル区分名 */
    DeliveryCycleDivName: string;
    /** 商品マスタ単価 */
    GoodsPrice: string;
    /** 値引単価 */
    DiscountUnitPrice: string;
    /** 値引率 */
    DiscountRate: string;
    /** 忘れず注文商品ID */
    RememberGoodsId: string;
    /** 注文数変更用注文コード */
    OrderChangeOrderNum: string;
  }[];
}

/**
 * 忘れず注文商品一覧 取得サービス
 * @export GetRememberGoodsListService
 * @class GetRememberGoodsListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetRememberGoodsListService extends PlessJsonResponderSub<GetRememberGoodsListResponse> {
  model: KYMW7400Model;
  private requestData: GetRememberGoodsListRequest;
  private successFunc: (data: GetRememberGoodsListResponse) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetRememberGoodsListService
   */
  private getBody(requestPageNo: number): PlessRequest {
    // リクエストを設定 (検索条件を指定しない項目は検索条件に含めない＝空文字にする)
    this.requestData = {
      search: {
        RememberGoodsList: {
          condition: {
            OrderReceptionCatalog: this.model.searchCondition.OrderReceptionCatalog ?? '',
            DeliveryCatalog: this.model.searchCondition.DeliveryCatalog ?? '',
            OrderNum: this.model.searchCondition.OrderNum ?? '',
            ClassCode: this.model.searchCondition.ClassCode ?? '',
            BuyerCode: this.model.searchCondition.BuyerCode ?? '',
            ItemCode: this.model.searchCondition.ItemCode ?? '',
            Pcode: this.model.searchCondition.Pcode ?? '',
            GuideGoodsName: this.model.searchCondition.GuideGoodsName ?? '',
            GuideStandardName: this.model.searchCondition.GuideStandardName ?? '',
            Page: requestPageNo.toString(),
          }
        }
      }
    };

    return new PlessRequest(this.requestData);
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetRememberGoodsListService
   */
  execute(model: KYMW7400Model, requestPageNo: number, func?:(data: GetRememberGoodsListResponse) => void): void {
    this.model = model;
    if (func) {
      this.successFunc = func;
    }
    this.send('getRememberGoodsList', this.getBody(requestPageNo));
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetRememberGoodsListService
   */
  success(data: GetRememberGoodsListResponse) {
    // UI 描画とユーザ操作の仲介はコンポーネントに任せる
    if (this.successFunc) {
      this.successFunc(data);
    }
  }

}
